import {
  Button,
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';

import { NextImage } from '~components/NextImage/NextImage';
import { NextImageMods } from '~components/NextImage/NextImage.types';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockBanner.module.scss';
import {
  ContentBlockBannerProps,
  ImagePosition,
} from './ContentBlockBanner.types';

export function ContentBlockBanner({
  title,
  text,
  button,
  image,
  imagePosition = ImagePosition.Left,
  ...sectionProps
}: ContentBlockBannerProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <article
        className={classNames(styles.article, styles[`media_${imagePosition}`])}
      >
        {image && (
          <NextImage
            className={styles.media}
            mods={[NextImageMods.FitContain]}
            {...image}
          />
        )}
        <div className={styles.content}>
          <Typography
            tagName={TypographySizes.h3}
            mods={[TypographyMods.titleL]}
          >
            {title}
          </Typography>
          <Typography className={styles.text} mods={[TypographyMods.titleS]}>
            {text}
          </Typography>
          <div className={styles.buttonContainer}>
            {button && (
              <Button
                className={styles.button}
                mod="primary"
                size="m"
                text={button.text}
                href={button.href}
              />
            )}
          </div>
        </div>
      </article>
    </ContentBlockWrapper>
  );
}
